import React from 'react';
import ContentManagementContainer from '@src/containers/ContentManagement';

const ContentManagement = () => <ContentManagementContainer />;

export default ContentManagement;
